import OtpInput from "react-otp-input";
import NiceButton from "../../pictures/NiceButton";
import {verifyLoginWithEmail} from "../../../util/api";
import React, {useEffect, useState} from "react";
import 'styles/login/basic/OtpTab.css';

const OtpTab = ({otpKey, email, onMissingUserName}) => {
    const [otpSecret, setOtpSecret] = useState("");
    const [isSending, setIsSending] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [sendAttempts, setSendAttempts] = useState(1);

    const sanitizeOtp = (value) =>
        (value || "").replace(/[^a-zA-Z0-9]/g, "").slice(0, 12);

    useEffect(() => {
        setErrorMessage("");
        // auto-send only for first 10 attempts
        if (otpSecret.length === 12 && sendAttempts <= 3) {
            handleSend();
        }
    }, [otpSecret, sendAttempts]);

    const handleSend = async () => {
        if (isSending || otpSecret.length !== 12) {
            return;
        }

        setSendAttempts((prev) => prev + 1);
        setIsSending(true);

        try {
            const hasNickname = await verifyLoginWithEmail(otpKey, otpSecret);
            localStorage.setItem("isLoggedIn", "true");
            if (hasNickname.message === "true") {
                window.location.reload();
                return;
            }
            onMissingUserName();
        } catch (error) {
            if (error.status !== 400) {
                setErrorMessage(
                    "Something went wrong. Please try again later or contact us."
                );
            } else {
                const errorBodyString = await error.body;
                try {
                    const errorBody = JSON.parse(errorBodyString);
                    if (errorBody.length > 0) {
                        setErrorMessage(errorBody[0].errorText);
                    }
                } catch (parseError) {
                    setErrorMessage(
                        "Something went wrong. Please try again later or contact us."
                    );
                }
            }
        } finally {
            setIsSending(false);
        }
    };

    const handlePaste = async () => {
        const text = await navigator.clipboard.readText();
        setOtpSecret(sanitizeOtp(text));
    };

    return (
        <div className="otp-tab">
            <p style={{marginTop: '34px', marginBottom: '0px', fontSize: '18px', color: '#1b551e'}}>
                Verification e-mail was sent to
            </p>
            <div style={{color: '#1b551e', wordBreak: 'break-all'}}><b>{email}</b></div>

            <div className="otp-wrapper">
                <div style={{scale: '1.3'}}>
                    <OtpInput
                        value={otpSecret}
                        onChange={(value) => setOtpSecret(sanitizeOtp(value))}
                        numInputs={12}
                        inputType="text"
                        shouldAutoFocus
                        containerStyle={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        renderSeparator={(index) =>
                            index === 3 || index === 7 ? <span className="otp-sep">-</span> : null
                        }
                        renderInput={(inputProps) => {
                            const {style, ...rest} = inputProps;
                            return (
                                <span className="code-input-wrapper">
                                <input
                                    {...rest}
                                    className="code-input-inner"
                                    style={{all: "unset", width: "10px", textAlign: "center"}}
                                />
                        </span>
                            );
                        }}
                    />
                </div>
            </div>

            <div className="sign-input-error">
                {errorMessage}
            </div>

            <div className="otp-button-wrapper">
                <NiceButton onClick={handlePaste} text="Paste" disabled={isSending}/>
                {sendAttempts > 3 && (
                    <div style={{marginLeft: '12px'}}>
                        <NiceButton
                            onClick={handleSend}
                            text={"Send"}
                            disabled={isSending || otpSecret.length !== 12 || errorMessage}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default OtpTab;
